import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { ApiServiceHolder } from '@core/utils/api-service-holder';
import { PlatformService } from '@shared/services/platform-service.service';
import { REQUEST } from '@shared/tokens/server.token';
import { Observable, map, of } from 'rxjs';
import { IUser } from 'src/app/users-manager/interfaces/user.interface';
import {
  IUserActivationDto,
  IUserAuthenticateRequest,
  IUserConnectedDto,
  IUserEventRegistrationDto,
  IUserLoginDto,
  IUserRegistrationDto,
} from '../interfaces/login.interfaces';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  _api = inject(ApiService);
  platformService = inject(PlatformService);

  req = this.platformService.run({
    server: () => inject(REQUEST),
    browser: () => null,
  });

  register(item: IUserRegistrationDto): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.register(item));
  }

  registerForEvent(item: IUserEventRegistrationDto): Observable<IUser> {
    return this._api.request(ApiServiceHolder.user.registerForEvent(item));
  }

  activateUser(item: IUserActivationDto): Observable<IUserAuthenticateRequest> {
    return this._api.request(ApiServiceHolder.user.activateUser(item));
  }

  requestMagicLogin(payload: { email: string; languageCode: string; redirectPath?: string }): Observable<void> {
    return this._api.request(ApiServiceHolder.email.sendMagicLoginEmail(payload));
  }

  magicLoginWithCode(requestCode: string): Observable<IUserAuthenticateRequest> {
    return this._api.request(ApiServiceHolder.user.magicLoginWithCode(requestCode));
  }

  authenticate(item: IUserLoginDto): Observable<IUserAuthenticateRequest> {
    return this._api.request(ApiServiceHolder.user.authenticate(item));
  }

  logout(): Observable<void> {
    return this._api.request(ApiServiceHolder.user.logout());
  }

  ping(): Observable<IUserConnectedDto> {
    return this.platformService.run({
      server: () => {
        if (this.req.cookies['MemoraBid']) {
          return this._api.request(ApiServiceHolder.user.ping());
        }
        return of(null);
      },
      browser: () => {
        return this._api.request(ApiServiceHolder.user.ping());
      },
    });
  }

  // get user existence by username/email anonymously
  userExists(username: string): Observable<boolean> {
    return this._api
      .request<{ exists: boolean }>(ApiServiceHolder.user.exists(username))
      .pipe(map((res) => !!res?.exists));
  }
}
